<div class="card">
  <div class="card-body">
    <div class=" first-sec">
      <div class="logo-sec">
        <div class="logo">
          <img src="/images/home/Mask group.svg" alt="logo">
        </div>
        <p>Join a welcoming community designed to help international students
          connect, learn, and enjoy their time in Berlin.</p>
      </div>
      <div class="social-icons">
        <img src="/images/home/GmailIcon.svg" alt="gmail">
        <img src="/images/home/WhatsAppIcon.svg" alt="linkedin">
        <img src="/images/home/LinkedInIcon.svg" alt="linkedin">
        <img src="/images/home/FacebookIcon.svg" alt="facebook">
      </div>
    </div>
    <div class="card-content">
      <div class=" quick-links">
        <span style="color: #fff; font-weight: 500; font-size: 16px;">Quick Links</span>
        <div>
          <a href="">Home
            <svg class="arc-home" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              transform="rotate(145)">
              <g id="SVGRepo_bgCarrier" stroke-width="1"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M10,10 Q50,45 90,10" stroke="#fff" stroke-width="0.8" stroke-linecap="round"></path>
              </g>
            </svg>
          </a>
        </div>
        <div>
          <a href="">Services
            <svg class="arc-services" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              transform="rotate(145)">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M10,10 Q50,45 90,10" stroke="#fff" stroke-width="0.4800000000000001" stroke-linecap="round">
                </path>
              </g>
            </svg>
          </a>
        </div>
        <div>
          <a href="">Event Highlights
            <svg class="arc-event" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              transform="rotate(145)">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M10,10 Q50,45 90,10" stroke="#fff" stroke-width="0.3" stroke-linecap="round"></path>
              </g>
            </svg>
          </a>
        </div>
        <div>
          <a href="">Our Plans
            <svg class="arc-plan" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              transform="rotate(145)">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M10,10 Q50,45 90,10" stroke="#fff" stroke-width="0.4800000000000001" stroke-linecap="round">
                </path>
              </g>
            </svg>
          </a>
        </div>
      </div>
      <div class=" contact-us">
        <span style="color: #fff; font-weight: 500; font-size: 16px;">Contact us</span>
        <div>
          <a href="">Contact Us
            <svg class="arc-contact" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              transform="rotate(145)">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M10,10 Q50,45 90,10" stroke="#fff" stroke-width="0.4800000000000001" stroke-linecap="round">
                </path>
              </g>
            </svg>
          </a>
        </div>
        <div>
          <a href="">About Us
            <svg class="arc-about" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              transform="rotate(145)">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M10,10 Q50,45 90,10" stroke="#fff" stroke-width="0.4800000000000001" stroke-linecap="round">
                </path>
              </g>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center copy-right" style=" border-top: #2B3C56 1px solid;">
    <p>2025 • All Right Reserved</p>
  </div>
</div>
